module.exports = __webpack_public_path__ + "img/7_big.69957138.png";